






import Vue from 'vue';
import mainContent from '@/components/page/announceContent/index.vue';

export default Vue.extend({
    name: 'financialClassContent',
    components: {
        mainContent
    },
    data() {
        return {
            data: {}
        };
    },
    created() {
        window.FRSToolV3.getAnnounceContent({
            type: this.$route.params.type,
            articleId: this.$route.params.id
        }).then((res: any) => {
            this.data = res.result.data;
        });
    }
});
